import { types as vesselTypes } from 'constants/vesselTypes';

export const notifications = {
    error(message) {
        return {
            title: 'Error',
            message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3,
        };
    },
    success(message) {
        return {
            title: 'Success',
            message,
            level: 'success',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3,
        };
    },
};

export const selectTypes = (vessel, vesselDwtTypes) => {
    const res = {};
    if (vesselTypes.includes(vessel.typeByPurpose)) {
        res.typeByPurpose = vessel.typeByPurpose;
    }

    const foundGroup = vesselDwtTypes.find(v => v.min <= vessel.deadWeight.sDWT &&
            vessel.deadWeight.sDWT <= v.max &&
            v.typeByPurpose.includes(vessel.typeByPurpose));

    if (foundGroup) {
        res.vesselDwtGroup = foundGroup;
    } else {
        res.vesselDwtGroup = {};
    }
    
    return res;
};



// WEBPACK FOOTER //
// ./app/components/TcIndex/common.js